export const QC_ADMINISTRATOR = "QC-ADMINISTRATOR"
export const COPYRIGHT = "https://enqc-adm.abacus.co.id"
export const BASE_URL = window.location.port?'http://217.15.166.218:6222/api':'https://enqc-api.abacus.co.id/api'
export const DEBUG = false
